export const namespace = (namespace, block) => {
  let target = window
  namespace.split('.').forEach((name) => {
    target = target[name] || (target[name] = {})
  })
  return block(target, namespace)
}
